function isDesktopNavigation() {
  return window.matchMedia('(min-width: 990px)').matches;
}

function getNavigationSection() {
  return document.querySelector('.section-navigation');
}

function getNavigationPanel() {
  const navigationSection = getNavigationSection();

  return navigationSection ? navigationSection.querySelector('.navigation') : null;
}

function getDrawerToggle() {
  return document.querySelector('#drawer');
}

function setExpandedState(element, isExpanded) {
  if (!element) return;

  if (window.A11Y && window.A11Y.setAriaExpanded) {
    window.A11Y.setAriaExpanded(element, isExpanded);
  } else {
    element.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  }
}

function setInertState(element, isInert) {
  if (!element) return;

  if (isInert) {
    element.setAttribute('inert', '');
  } else {
    element.removeAttribute('inert');
  }
}

function setMenuState(control, isOpen) {
  if (!control) return;

  const menuId = control.getAttribute('aria-controls');
  const menu = menuId ? document.getElementById(menuId) : null;
  const item = control.closest('.item-main');

  if (!menu) return;

  setExpandedState(control, isOpen);
  setInertState(menu, !isOpen);

  if (item) {
    item.classList.toggle('active', isOpen);
  }
}

function closeAllMenus() {
  document.querySelectorAll('.navigation .top-item.has-menu').forEach(function(control) {
    setMenuState(control, false);
  });
}

function setDrawerState(isOpen, returnFocusElement) {
  const navigationSection = getNavigationSection();
  const navigationPanel = getNavigationPanel();
  const drawerToggle = getDrawerToggle();

  if (!navigationSection || !navigationPanel) return;

  navigationSection.classList.toggle('active', isOpen);

  if (!isDesktopNavigation()) {
    setInertState(navigationPanel, !isOpen);
  } else {
    navigationPanel.removeAttribute('inert');
  }

  setExpandedState(drawerToggle, isOpen);

  if (isOpen) {
    const closeButton = navigationPanel.querySelector('[data-drawer="toggle"]');

    // The mobile drawer transitions from visibility:hidden to visible. Move focus
    // after the browser has applied the open state so keyboard users enter the
    // drawer instead of remaining on the header menu trigger.
    window.requestAnimationFrame(function() {
      window.requestAnimationFrame(function() {
        if (!navigationSection.classList.contains('active') || isDesktopNavigation()) return;

        if (window.A11Y && window.A11Y.trapFocus) {
          window.A11Y.trapFocus(navigationPanel, closeButton, {
            returnFocus: returnFocusElement || drawerToggle,
            escapeDeactivates: false,
            allowOutsideClick: true
          });
        } else if (closeButton && window.A11Y && window.A11Y.attemptFocus) {
          window.A11Y.attemptFocus(closeButton);
        } else if (closeButton) {
          closeButton.focus();
        }
      });
    });
  } else {
    if (window.A11Y && window.A11Y.removeFocusTrap) {
      window.A11Y.removeFocusTrap(navigationPanel, false);
    }

    closeAllMenus();

    const focusTarget = returnFocusElement || drawerToggle;

    if (focusTarget && window.A11Y && window.A11Y.attemptFocus) {
      window.A11Y.attemptFocus(focusTarget);
    } else if (focusTarget) {
      focusTarget.focus();
    }
  }
}

function syncNavigationState() {
  const navigationSection = getNavigationSection();
  const navigationPanel = getNavigationPanel();

  if (!navigationSection || !navigationPanel) return;

  if (isDesktopNavigation()) {
    if (window.A11Y && window.A11Y.removeFocusTrap) {
      window.A11Y.removeFocusTrap(navigationPanel, false);
    }

    navigationPanel.removeAttribute('inert');
    setExpandedState(getDrawerToggle(), false);
  } else {
    const isOpen = navigationSection.classList.contains('active');

    if (!isOpen && window.A11Y && window.A11Y.removeFocusTrap) {
      window.A11Y.removeFocusTrap(navigationPanel, false);
    }

    setInertState(navigationPanel, !isOpen);
    setExpandedState(getDrawerToggle(), isOpen);
  }

  closeAllMenus();
}

document.querySelectorAll('[data-drawer]').forEach(function(elem) {
  elem.addEventListener('click', function(e) {
    e.preventDefault();

    const navigationSection = getNavigationSection();
    if (!navigationSection) return;

    const isOpen = navigationSection.classList.contains('active');

    if (isOpen) {
      // Closing from the overlay or drawer close button should always return
      // focus to the header menu trigger, not to the element being hidden.
      setDrawerState(false, getDrawerToggle());
    } else {
      setDrawerState(true, this);
    }
  });
});

document.querySelectorAll('.navigation .top-item.has-menu').forEach(function(control) {
  const item = control.closest('.item-main');

  control.addEventListener('click', function(e) {
    if (!isDesktopNavigation()) {
      e.preventDefault();

      const isOpen = item && item.classList.contains('active');

      setMenuState(control, !isOpen);
    }
  });

  if (item) {
    item.addEventListener('mouseenter', function() {
      if (!isDesktopNavigation()) return;

      setMenuState(control, true);
    });

    item.addEventListener('mouseleave', function() {
      if (!isDesktopNavigation()) return;

      setMenuState(control, false);
    });
  }

  control.addEventListener('blur', function() {
    if (!isDesktopNavigation()) return;

    const menuId = control.getAttribute('aria-controls');
    const menu = menuId ? document.getElementById(menuId) : null;

    if (!menu) return;

    setTimeout(function() {
      if (!menu.contains(document.activeElement) && document.activeElement !== control) {
        setMenuState(control, false);
      }
    }, 100);
  });
});

// Wire keyboard handlers using shared A11Y helpers if available
document.addEventListener('DOMContentLoaded', function() {
  syncNavigationState();

  if (window.A11Y && window.A11Y.attachMenubarKeyboardHandlers) {
    const menubar = document.querySelector('.navigation .main');

    if (menubar) {
      window.A11Y.attachMenubarKeyboardHandlers(menubar, { topItemSelector: '.top-item' });
    }
  }
});

window.addEventListener('resize', function() {
  syncNavigationState();
});

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;

  const navigationSection = getNavigationSection();

  if (navigationSection && navigationSection.classList.contains('active') && !isDesktopNavigation()) {
    setDrawerState(false);
    return;
  }

  closeAllMenus();
});

document.querySelectorAll('.link-block-title.has-children a').forEach(function(elem) {
  elem.addEventListener('click', function(e) {
    if (isDesktopNavigation()) return;

    e.preventDefault();

    const item = this.closest('.menu-column');

    if (!item) return;

    item.classList.toggle('active');
  });
});

document.querySelectorAll('.link-block-title.empty-space').forEach(function(elem) {
  const thisMenuCol = elem.closest('.menu-column');

  if (!thisMenuCol) return;

  let prevList = thisMenuCol.previousElementSibling;

  if (!prevList) return;

  if (prevList.classList.contains('extended-column')) {
    prevList = thisMenuCol.previousElementSibling.previousElementSibling;
  }

  if (!prevList || !elem.nextElementSibling) return;

  const clone = elem.nextElementSibling.cloneNode(true);

  clone.classList.add('clone');
  prevList.appendChild(clone);
});

document.querySelectorAll('.button-cart-loader').forEach(function(elem) {
  elem.addEventListener('click', function() {
    this.classList.add('button-loading');
  });
});
